// extracted by mini-css-extract-plugin
export default {"carousel-swiper":"qvwh4","carousel-slide":"qWlT8"};